var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-card',{attrs:{"title":"اطلاعات اصلی","separator":""}},[_c('admin-department-edit-form',{attrs:{"department-resource":_vm.department.data,"header-text":"ویرایش اطلاعات دپارتمان","chat-id-activate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }